/**
 * Commerce orders domain — admin UI registration (Sub-project III).
 *
 * Injects per-record action toolbars into the generic-framework
 * detail pages via the `detailHeader` slot.
 */
import { registerAdminUI } from '@/admin/generic/registry';
import OrderActions from './components/OrderActions.vue';
import ReservationActions from './components/ReservationActions.vue';

registerAdminUI('commerce.order', {
    slots: {
        detailHeader: OrderActions,
    },
});

registerAdminUI('commerce.reservation', {
    slots: {
        detailHeader: ReservationActions,
    },
});
